export class NotificationBase {
    constructor() {
    }

    activate(model) {
        this.notification = model.notification;
        this.icon = model.icon;
        this.parent = model.parent;
    }

    getIcon()
    {
        return this.icon;
    }
}
